import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {ParameterizedMessage} from "@common-module/modelinterfaces/paramitized-message.model";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {UnitState} from "@common-module/modelinterfaces/unit-state.model";
import {UnitStateConst} from "../../../../shared/utils/unit-state.const";
import {Driver} from "@common-module/modelinterfaces/driver.model";
import {MatIconModule} from "@angular/material/icon";
import { NgClass } from "@angular/common";
import {MatTooltip} from "@angular/material/tooltip";
import {TimeFromNowTextPipe} from "@common-module/pipes/time-from-now-text.pipe";
import {DriverWithAvatarComponent} from "../../../../shared/components/driver-with-avatar/driver-with-avatar.component";

@Component({
    selector: 'app-short-unit-state-info',
    imports: [
    MatIconModule,
    NgClass,
    MatTooltip,
    TranslateModule,
    TimeFromNowTextPipe,
    DriverWithAvatarComponent
],
    templateUrl: './short-unit-state-info.component.html',
    styleUrls: ['./short-unit-state-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShortUnitStateInfoComponent {

  readonly STOP_SPEED = UnitStateConst.STOP_SPEED;

  warningText = '';
  alertText = '';
  secondsAgo = 0;
  speed = 0;
  driver: Driver;

  constructor(private translateService: TranslateService) {
  }

  @Input() highlight = false;
  @Input() showZeroSpeed = false;
  @Input() showAlertMessages = true;

  @Input() set unitState(unitState: UnitState) {
    this.warningText = this.convertWarningsInString(unitState.warnings);
    this.alertText = this.convertWarningsInString(unitState.alerts);
    this.secondsAgo = unitState.connectionState.secondsAgo;
    this.speed = unitState.gpsState?.speed || 0;
    this.driver = unitState.driver;
  }

  public convertWarningsInString(messages: ParameterizedMessage[]): string {
    return messages.map(m => this.translateService.instant('parameterized-message.' + m.code, m.params)).join(`;\n`);
  }
}
